<kendo-dialog [title]="referenceDataLabels.ApplicantOrderWarningTitle | localizeLabel" (close)="close()">
    <div class="vo-body-regular-14 my-15"
        [innerHTML]="referenceDataLabels.ApplicantOrderProcessContent | localizeLabel"></div>
    <div class="vo-info-box--warning">
        <h1 class="vo-heading-bold-18 mb-15" [innerHTML]="referenceDataLabels.ApplicantOrderWarning | localizeLabel">
        </h1>
        <div class="vo-body-regular-14"
            [innerHTML]="referenceDataLabels.ApplicantOrderWarningContent | localizeLabel"></div>
    </div>


    <kendo-dialog-actions class="modal-buttons">
        <div class="left-column mb-15 mb-md-0">
            <a (click)="close()" [innerHtml]="referenceDataLabels.CancelId|localizeLabel"
                class="link vo-secondary-button-1"></a>
        </div>
        <div class="right-column">
            <button (click)="confirm()" [innerHtml]="referenceDataLabels.FinaliseSubmission | localizeLabel"
                class="primary-button vo-primary-button-1"></button>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>